import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
            <a
              data-video="https://drivesvideo.s3.amazonaws.com/Drives+Baseball+(Outs+Only)+Draft+7.mp4"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/images/video-placeholder.png')}
                alt="video-placeholder" />
            </a>
          </div>
          <div className="hero-content">
            <h1 className="f3 f1-l fw2 mb3 mt4 mt0-ns hero-title">SCORE EVERY WEEKEND</h1>
            <div className="container">
              <p className="reveal-from-bottom hero-desc" data-reveal-delay="400">
                {/* Drives Football is an in-game app that lets users buy or sell the outcome of each offensive play
                or possession. It is a social game where players compete against the computer, friends or in open
                Contests and Leagues. */}
                Drives Football is an in-game app that lets users buy or sell the outcome of each
                offensive play or possession. It is a social game where players compete against the
                computer, friends or in open Contests and Leagues.
              </p>
              <div className="reveal-from-bottom" data-reveal-delay="600">

                {/* <Button tag="a" color="dark" wideMobile href="/about">
                  Learn More
                  </Button> */}

              </div>
            </div>
          </div>
          <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://drivesvideo.s3.amazonaws.com/Drives+Baseball+(Outs+Only)+Draft+7.mp4"
            videoTag="iframe" />
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;